export interface GalleryManifest {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  banner: string; // filename only, e.g. "TaiLoganWedding232.jpg"
  images: string[]; // filenames only
}

export interface GalleryImage {
  filename: string;
  thumbUrl: string;
  fullUrl: string;
}

export interface GalleryBanner {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  url: string; // constructed full-size URL
}

export interface Gallery {
  manifest: GalleryManifest;
  banner: GalleryBanner;
  images: GalleryImage[];
}

export function buildGalleryBanner(manifest: GalleryManifest): GalleryBanner {
  return {
    id: manifest.id,
    title: manifest.title,
    subtitle: manifest.subtitle,
    description: manifest.description,
    url: `/photo/full/${manifest.id}/${manifest.banner}`
  };
}

export function buildGalleryImages(manifest: GalleryManifest): GalleryImage[] {
  return manifest.images.map((filename) => ({
    filename,
    thumbUrl: `/photo/thumb/${manifest.id}/${filename}`,
    fullUrl: `/photo/full/${manifest.id}/${filename}`
  }));
}

export function buildGallery(manifest: GalleryManifest): Gallery {
  return {
    manifest,
    banner: buildGalleryBanner(manifest),
    images: buildGalleryImages(manifest)
  };
}
